import { render, staticRenderFns } from "./AppBarAdmin.vue?vue&type=template&id=70e0a07a"
import script from "./AppBarAdmin.vue?vue&type=script&lang=js"
export * from "./AppBarAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports